<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconColumns_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M1 11.846V4.058a1.5 1.5 0 0 1 .458-1.1 1.5 1.5 0 0 1 1.1-.458h10.884a1.5 1.5 0 0 1 1.1.458 1.5 1.5 0 0 1 .458 1.1v7.788a1.5 1.5 0 0 1-.458 1.1 1.5 1.5 0 0 1-1.1.458H2.558a1.5 1.5 0 0 1-1.1-.457 1.5 1.5 0 0 1-.458-1.1m1.538 0h2.59V4.058h-2.59zm4.148 0h2.59V4.058h-2.59zm4.147 0h2.59V4.058h-2.59z"
    />
</svg>
